import { COLOR_ACCENT, COLOR_BUTTON_SECONDARY, COLOR_PLUG_GRADIENT } from '../colors.constants';

export const colorsProgressBar = {
  colorsProgressBarBg: COLOR_BUTTON_SECONDARY,
  colorsProgressBarFilled: COLOR_ACCENT,
  colorsProgressBarPlug: COLOR_PLUG_GRADIENT,
};
